import formDesign from './_src/formDesign.vue'
import dragFormWraper from './_src/dragFormWraper'
formDesign.install = function(Vue) {
  Vue.component(formDesign.name, formDesign)
  Vue.component(dragFormWraper.name, dragFormWraper)
}

export default formDesign